/**
 * 新增修改完成调用 modalFormOk方法 编辑弹框组件ref定义为modalForm
 * 高级查询按钮调用 superQuery方法  高级查询组件ref定义为superQueryModal
 * data中url定义 list为查询列表  delete为删除单条记录  deleteBatch为批量删除
 */
import { filterObj } from '@/utils/util';
import {
  postAction,
  getAction,
  downFiles,
  getFileAccessHttpUrl
} from '@/api/manage';
import Vue from 'vue';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import { handleName } from '@/utils/common';

export const JeecgListMixin = {
  data() {
    return {
      //token header
      tokenHeader: { 'X-Access-Token': Vue.ls.get(ACCESS_TOKEN) },
      /* 查询条件-请不要在queryParam中声明非字符串值的属性 */
      queryParam: {},
      /* 数据源 */
      dataSource: [],
      firstDataId: '', //loaddata默认展示第一条数据的id
      /* 分页参数 */
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      /* 排序参数 */
      isorter: {
        column: 'updateTime',
        order: 'desc'
      },
      /* 筛选参数 */
      filters: {},
      /* table加载状态 */
      loading: false,
      /* table选中keys*/
      selectedRowKeys: [],
      /* table选中records*/
      selectionRows: [],
      /* 查询折叠 */
      toggleSearchStatus: false,
      /* 高级查询条件生效状态 */
      superQueryFlag: false,
      /* 高级查询条件 */
      superQueryParams: '',
      /** 高级查询拼接方式 */
      superQueryMatchType: 'and',
      chatParam: {},
      chatRes: [],
      warningparams: {},
      flg: null //处理创建人的flg，创建人需要去字典里面查
    };
  },
  created() {
    if (!this.disableMixinCreated) {
      console.log(' -- mixin created -- ');
      this.paramsInit();
      if (!this.$route.query.condition) {
        if (!this.$route.query.warningId) {
          this.loadData(1);
        }
      }
      //初始化字典配置 在自己页面定义
      this.initDictConfig();
    }
  },
  methods: {
    paramsInit() {},
    loadData(arg) {
      console.log(this.$route.query);
      if (!this.url.list) {
        this.$message.error('请设置url.list属性!');
        return;
      }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      var params = this.getQueryParams(); //查询条件
      var params1 = this.getQueryParams1(); //查询条件
      var params2 = this.getQueryParams2(); //查询条件
      this.loading = true;
      if (this.url.list.includes('/groupBarcode/queryGroupChat')) {
        getAction(this.url.list, params1).then(res => {
          if (res.success) {
            this.dataSource = [];
            if (!res.result.list) {
              this.loading = false;
              this.firstDatafn();
              return;
            }
            res.result.list &&
              res.result.list.forEach(item => {
                if (item.imageName) {
                  item.imageName = '已上传';
                  this.dataSource.push(item);
                } else {
                  item.imageName = '未上传';
                }
              });
            // this.dataSource = res.result.list
            this.chatRes = res.result;
          }
          if (res.code === 510) {
            this.$message.warning(res.message);
          }
          this.loading = false;
          this.firstDatafn();
        });
      } else if (this.url.list.includes('/warning/list')) {
        getAction(this.url.list, params2).then(res => {
          if (res.success) {
            this.dataSource = res.result;
            // this.chatRes = res.result
          }
          if (res.code === 510) {
            this.$message.warning(res.message);
          }
          this.loading = false;
          this.firstDatafn();
        });
      } else if (this.url.list.includes('/zx/findZx')) {
        getAction(this.url.list, params).then(res => {
          if (res.success) {
            // this.dataSource = res.result.records;
            this.dataSource = res.result;
            this.chatRes = res.result;
            this.ipagination.total = res.result.total;
          }
          if (res.code === 510) {
            this.$message.warning(res.message);
          }
          this.loading = false;
          this.firstDatafn();
        });
      } else if (this.url.list.includes('justThis')) {
        let url =
          process.env.VUE_APP_CMS_WECHATCUSTOMER + '/wechatwork/client/data';
        params.groupSendMaterialId = sessionStorage.getItem(
          'groupSendMaterialId'
        );
        getAction(url, params).then(res => {
          console.log(this.url.list, '==========');
          if (res.success) {
            // this.dataSource = res.result.records;
            if (res.result.records) {
              this.dataSource = res.result.records;
            } else if (res.result.list) {
              this.dataSource = res.result.list;
            } else {
              this.dataSource = res.result;
            }
            this.chatRes = res.result;
            this.ipagination.total = res.result.total;
          }
          if (res.code === 510) {
            this.$message.warning(res.message);
          }
          this.loading = false;
          this.firstDatafn();
        });
      } else {
        if (sessionStorage.getItem('groupSendMaterialId')) {
          params.groupSendMaterialId = sessionStorage.getItem(
            'groupSendMaterialId'
          );
        }
        getAction(this.url.list, params).then(res => {
          console.log(this.url.list, '==========');
          if (res.success) {
            // this.dataSource = res.result.records;
            if (res.result.records) {
              this.dataSource = res.result.records;
            } else if (res.result.list) {
              this.dataSource = res.result.list;
            } else {
              this.dataSource = res.result;
            }
            this.chatRes = res.result;
            this.ipagination.total = res.result.total;
          }
          if (res.code === 510) {
            this.$message.warning(res.message);
          }
          this.loading = false;
          this.firstDatafn();
        });
      }
    },
    firstDatafn() {},
    initDictConfig() {
      // console.log("--这是一个假的方法!")
    },
    handleSuperQuery(params, matchType) {
      //高级查询方法
      if (!params) {
        this.superQueryParams = '';
        this.superQueryFlag = false;
      } else {
        this.superQueryFlag = true;
        this.superQueryParams = JSON.stringify(params);
        this.superQueryMatchType = matchType;
      }
      this.loadData(1);
    },
    getQueryParams() {
      //获取查询条件
      let sqp = {};
      if (this.superQueryParams) {
        sqp['superQueryParams'] = encodeURI(this.superQueryParams);
        sqp['superQueryMatchType'] = this.superQueryMatchType;
      }
      var param = Object.assign(
        sqp,
        this.isorter,
        this.filters,
        this.queryParam,
        this.chatParam,
        this.warningparams
      );
      if (this.flg) {
        param.createName = handleName(this.queryParam.createName);
      }
      console.log(param);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    getQueryParams1() {
      //获取查询条件
      let sqp = {};
      if (this.superQueryParams) {
        sqp['superQueryParams'] = encodeURI(this.superQueryParams);
        sqp['superQueryMatchType'] = this.superQueryMatchType;
      }
      var param = Object.assign(
        sqp,
        this.isorter,
        this.filters,
        this.queryParam,
        this.chatParam,
        this.warningparams
      );
      param.field = this.getQueryField();
      param.pageNo = '';
      param.pageSize = 10000000; //为了获取所以群聊列表，所以用一个比较大的数字（不固定）
      return filterObj(param);
    },
    getQueryParams2() {
      //获取查询条件
      let sqp = {};
      if (this.superQueryParams) {
        sqp['superQueryParams'] = encodeURI(this.superQueryParams);
        sqp['superQueryMatchType'] = this.superQueryMatchType;
      }
      var param = Object.assign(
        sqp,
        this.isorter,
        this.filters,
        this.queryParam,
        this.chatParam,
        this.warningparams
      );
      param.field = this.getQueryField();
      return filterObj(param);
    },
    getQueryField() {
      //TODO 字段权限控制
      var str = 'id,';
      this.columns.forEach(function(value) {
        str += ',' + value.dataIndex;
      });
      return str;
    },

    onSelectChange(selectedRowKeys, selectionRows) {
      // console.log(selectionRows, 1111);
      // let arr = []
      // selectedRowKeys = []
      // if(selectionRows.length > 0) {
      //   // if(selectionRows[0].imageName == '未上传') {
      //   //   this.$message.warning('当前群聊未上传二维码，请前往客户群聊配置!')
      //   //   return
      //   // }
      //   selectionRows.forEach(item => {
      //     if(item.imageName === '已上传') {
      //       arr.push(item)
      //     }
      //   })
      // }
      // arr.forEach (item => selectedRowKeys.push(item.groupChatId))
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
      console.log(this.name);
      if (this.name == 'courseManageModal') {
        let courseList = selectedRowKeys;
        this.form.setFieldsValue({
          courseList
        });
      }
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    searchQuery(flg) {
      this.flg = flg;
      this.paramsInit();
      this.loadData(1);
    },
    superQuery() {
      this.$refs.superQueryModal.show();
    },
    resetparamsInit() {},
    queryChatData() {},
    searchReset() {
      this.warningparams = {};
      this.queryParam = {};
      this.resetparamsInit();
      if (this.$route.query.type != 4) {
        this.loadData(1);
      }
    },
    batchDel: function() {
      if (!this.url.deleteBatch) {
        this.$message.error('请设置url.deleteBatch属性!');
        return;
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = '';
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }
        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function() {
            that.loading = true;
            postAction(that.url.deleteBatch, { ids: ids })
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.loadData();
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          }
        });
      }
    },
    handleDelete: function(id) {
      if (!this.url.delete) {
        this.$message.error('请设置url.delete属性!');
        return;
      }
      var that = this;
      postAction(that.url.delete, { id: id }).then(res => {
        if (res.success) {
          that.$message.success(res.message);
          that.loadData();
        } else {
          that.$message.warning(res.message);
        }
      });
    },
    handleEdit: function(record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '编辑';
      this.$refs.modalForm.disableSubmit = false;
    },
    handleAdd: function(course) {
      console.log(course);
      if (course) {
        if (course.type == 'click') {
          course = undefined;
        }
      }

      this.$refs.modalForm.add(course);
      this.$refs.modalForm.title = '新增';
      this.$refs.modalForm.disableSubmit = false;
    },
    handleAddValue: function(item) {
      console.log(item);
      this.$refs.modalForm.add(item);
      this.$refs.modalForm.title = '编辑';
      this.$refs.modalForm.disableSubmit = false;
    },
    handleTableChange(pagination, filters, sorter) {
      // this.onClearSelected()//分页切换时清空表格选中=======>
      //分页、排序、筛选变化时触发
      //TODO 筛选
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      this.ipagination = pagination;
      this.loadData();
    },
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    // 给popup查询使用(查询区域不支持回填多个字段，限制只返回一个字段)
    getPopupField(fields) {
      return fields.split(',')[0];
    },
    modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.loadData();
    },
    handleDetail: function(record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '详情';
      this.$refs.modalForm.disableSubmit = true;
    },
    /* 导出 */
    handleExportXls2() {
      let paramsStr = encodeURI(JSON.stringify(this.getQueryParams()));
      let url = `${process.env.VUE_APP_GATEWAY_URL +
        process.env.VUE_APP_CMS_SYSTEM}/${
        this.url.exportXlsUrl
      }?paramsStr=${paramsStr}`;
      window.location.href = url;
    },
    handleExportXls(fileName) {
      let paramsStr = encodeURI(JSON.stringify(this.getQueryParams()));

      // console.warn(paramsStr);
      if (!fileName || typeof fileName != 'string') {
        fileName = '导出文件';
      }
      let param = {};
      if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
        param['selections'] = this.selectedRowKeys.join(',');
      }
      console.log('导出参数', param);
      downFiles(`${this.url.exportXlsUrl}?paramsStr=${paramsStr}`, param).then(
        data => {
          if (!data) {
            this.$message.warning('文件下载失败');
            return;
          }
          if (typeof window.navigator.msSaveBlob !== 'undefined') {
            window.navigator.msSaveBlob(
              new Blob([data], { type: 'application/vnd.ms-excel' }),
              fileName + '.xls'
            );
          } else {
            let url = window.URL.createObjectURL(
              new Blob([data], { type: 'application/vnd.ms-excel' })
            );
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', fileName + '.xls');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link); //下载完成移除元素
            window.URL.revokeObjectURL(url); //释放掉blob对象
          }
        }
      );
    },
    /* 导入 */
    handleImportExcel(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        if (info.file.response.success) {
          // this.$message.success(`${info.file.name} 文件上传成功`);
          if (info.file.response.code === 201) {
            let {
              message,
              result: { msg, fileUrl, fileName }
            } = info.file.response;
            let href =
              process.env.VUE_APP_GATEWAY_URL +
              process.env.VUE_APP_CMS_SYSTEM +
              fileUrl;
            this.$warning({
              title: message,
              content: (
                <div>
                  <span>{msg}</span>
                  <br />
                  <span>
                    具体详情请{' '}
                    <a href={href} target="_blank" download={fileName}>
                      点击下载
                    </a>{' '}
                  </span>
                </div>
              )
            });
          } else {
            this.$message.success(
              info.file.response.message || `${info.file.name} 文件上传成功`
            );
          }
          this.loadData();
        } else {
          this.$message.error(
            `${info.file.name} ${info.file.response.message}.`
          );
        }
      } else if (info.file.status === 'error') {
        this.$message.error(`文件上传失败: ${info.file.msg} `);
      }
    },
    /* 图片预览 */
    getImgView(text) {
      if (text && text.indexOf(',') > 0) {
        text = text.substring(0, text.indexOf(','));
      }
      return getFileAccessHttpUrl(text);
    },
    /* 文件下载 */
    uploadFile(text) {
      if (!text) {
        this.$message.warning('未知的文件');
        return;
      }
      if (text.indexOf(',') > 0) {
        text = text.substring(0, text.indexOf(','));
      }
      let url = getFileAccessHttpUrl(text);
      window.open(url);
    }
  }
};
